import nudgeStore from '../store/Store';

export default function getNudgesCount(tableViewId: string): number {
    return nudgeStore.nudgedRows.filter(nudgedRow => nudgedRow.tableViewId === tableViewId).length;
}
